import { HTTPMethod } from 'helpers/method';
import { ENDPOINT } from 'services/configs/endpoint.constant';
import {
  AddQuestionParams,
  AddQuestionResponse,
  DeleteTaskParams,
  EditQuestionParams,
  EditTaskNamePayload,
  EditTaskNameResponse,
  GetDetailTaskParams,
  GetDetailTaskResponse,
  GetLatestMessageParams,
  GetTasksParams,
  GetTasksResponse,
  LatestMessageResponse,
} from 'services/summary/summary.type';

import { request } from '../configs/axiosConfig';

export const SummaryService = {
  getDetailTask: async (params: GetDetailTaskParams) => {
    return request<GetDetailTaskResponse>({
      method: HTTPMethod.GET,
      url: ENDPOINT.GET_DETAIL_TASK,
      params,
    });
  },
  getTasks: async (params: GetTasksParams) => {
    return request<GetTasksResponse>({
      method: HTTPMethod.GET,
      url: ENDPOINT.GET_TASKS,
      params,
    });
  },
  getLatestMessageTask: async (params: GetLatestMessageParams) => {
    return request<LatestMessageResponse>({
      method: HTTPMethod.GET,
      url: ENDPOINT.GET_LATEST_MESSAGE_SUMMARY,
      params,
    });
  },
  editTaskName: async (data: EditTaskNamePayload) => {
    return request<EditTaskNameResponse>({
      method: HTTPMethod.PUT,
      url: ENDPOINT.EDIT_TASK_NAME,
      data,
    });
  },
  deleteTask: async (params: DeleteTaskParams) => {
    return request({
      method: HTTPMethod.DELETE,
      url: ENDPOINT.DELETE_TASKS,
      params,
    });
  },
  addQuestion: async (data: AddQuestionParams) => {
    return request<AddQuestionResponse>({
      method: HTTPMethod.POST,
      url: ENDPOINT.ADD_QUESTION_SUMMARY,
      data,
    });
  },
  editQuestion: async (data: EditQuestionParams) => {
    return request({ method: HTTPMethod.PUT, url: ENDPOINT.EDIT_QUESTION_SUMMARY, data });
  },
};
